module.exports = __webpack_public_path__ + "media/images/nita_online_payment_steps/2-308ba838463040f98fdefa11ca870c80.png";